module.exports = __webpack_public_path__ + "static/media/offices (10).039e43f8.webp";